import { useQuery } from '@tanstack/react-query';
import { ProjectOpportunityService } from '../../services/project-opportunity';
import { IBaseUseQueryProps } from '../../interfaces/baseUseQueryProps';
import { IProjectOpportunity } from '../../interfaces/projectOpportunity';

export const CLIENT_PROJECTS_QUERY_KEY = 'client-projects';

interface IProps extends IBaseUseQueryProps<IProjectOpportunity[]> {
  clientId: number | null;
}

export const useGetClientProjectOpportunities = ({ clientId, ...props }: IProps) => useQuery({
  queryKey: [CLIENT_PROJECTS_QUERY_KEY, clientId],
  queryFn: () => ProjectOpportunityService.getClientProjects(clientId!),
  refetchOnWindowFocus: false,
  enabled: clientId !== null,
  ...props
});